/**
 * CRDT schema v2 marker type-guards.
 *
 * Narrow a `Marker` to a specific kind on a stream walk, and read a marker's `kind` generically.
 */

import { MARKER_KINDS, MarkerKind } from './constants'
import { AuditEventMarker, Marker, ParagraphChangeMarker, UtteranceChangeMarker } from './markers'

export const isParagraphChange = (marker: Marker): marker is ParagraphChangeMarker => marker.kind === MARKER_KINDS.paragraphChange

export const isUtteranceChange = (marker: Marker): marker is UtteranceChangeMarker => marker.kind === MARKER_KINDS.utteranceChange

export const isAuditEvent = (marker: Marker): marker is AuditEventMarker => marker.kind === MARKER_KINDS.auditEvent

export const getMarkerKind = (marker: Marker): MarkerKind => marker.kind
